module.exports = __webpack_public_path__ + "img/phone_bg.ecc10dca.png";